import type { InventoryVehicle } from '@carvana/merch-contracts';
import { useContext, useMemo } from 'react';
import { useFavoritesIds } from '~/context/common/UserContext';
import InventoryContext from '~/context/srp/InventoryContext';
import type { InventoryConditionalTile } from '~/contracts/srp';
import { injectConditionalTiles } from '~/hooks/srp/useConditionalTiles';

export default function useTiles(): Array<
  InventoryVehicle | InventoryConditionalTile
> {
  const { inventory } = useContext(InventoryContext);
  const favoritesIds = useFavoritesIds();

  return useMemo<Array<InventoryVehicle | InventoryConditionalTile>>(() => {
    if (!inventory.isLoaded || !inventory.data.inventory.vehicles.length) {
      return [];
    }

    const tileData = inventory.data.inventory.vehicles.map<InventoryVehicle>(
      vehicle => ({
        ...vehicle,
        isFavorite: favoritesIds.some(v => v === vehicle.vehicleId)
      })
    );
    const conditionalTileData = inventory.data.inventory.conditionalTiles || [];

    return injectConditionalTiles(tileData, conditionalTileData);
  }, [
    favoritesIds,
    inventory.data.inventory.conditionalTiles,
    inventory.data.inventory.vehicles,
    inventory.isLoaded
  ]);
}
